export default "__VITE_ASSET__CW3l3yQV__"